export default __webpack_public_path__ + "static/professional-services-60632874750d256e3ae52b9261f0c820.jpg";